import React from 'react';
import {withTranslation} from "react-i18next";
import { useHistory } from "react-router-dom";
import './cashPayment.scss';

const CashPayment = ({ t, clientInfo, branchInfo }) => {
  const history = useHistory();

  return (
    <div className={'payment-block cash-payment'}>
      {/*<h2>{ t('payment.payment_type.cash') }</h2>*/}
      <div className={'payment-content'} >
        <div>
          { t('payment.cash.notification', {phone_number: clientInfo.clientMobile}) }
        </div>
        <div className={'change-phone-number-block'}>
          { t('payment.cash.change_phone_notification')}
          <span
            className={'change-btn'}
            onClick={ ()=> {
              history.push(`/${branchInfo.branch_guid_code}/client`);
            }}
          >{ t('payment.cash.change_btn') }</span>
        </div>
      </div>
    </div>
  );
};


export default withTranslation()(CashPayment);
